const nf = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const inr = (v) => `₹${nf.format(Number(v || 0))}`;
export const num = (v) => nf.format(Number(v || 0));

export const toPaise = (s) => {
  const clean = String(s ?? "").replace(/,/g, "").trim();
  if (clean === "" || !/^\d*\.?\d*$/.test(clean)) return null;
  const n = Number(clean);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
};

export const fmtDate = (d) => (d ? `${d.slice(8, 10)}-${d.slice(5, 7)}-${d.slice(0, 4)}` : "—");

export const fmtDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" })
    : "—";

export const todayISO = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
export const currentMonth = () => todayISO().slice(0, 7);
export const monthLabel = (m) =>
  m ? new Date(`${m}-01T00:00:00`).toLocaleDateString("en-GB", { month: "short", year: "numeric" }) : "";

export const TXN = {
  opening: { label: "Opening Balance", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  advance: { label: "Advance Issued", cls: "bg-red-50 text-red-700 border-red-200" },
  deduction: { label: "Advance Deduction", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  adjustment: { label: "Balance Adjustment", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  reversal: { label: "Reversal/Correction", cls: "bg-slate-100 text-slate-700 border-slate-300" },
};

export const ROLE_LABEL = { admin: "Administrator", payroll: "Payroll/Accounts", readonly: "Read-Only", advance_manager: "Advance Manager", outlet_manager: "Outlet Manager" };
export const ADVANCE_ONLY = ["advance_manager", "outlet_manager"];
